<template>
  <div class="auth-form">
    <p class="auth-lead mb-3">E-mail a heslo</p>
    <argon-alert
      v-for="msg in errorMessages"
      :key="msg"
      class="text-sm text-center mb-3"
      icon="fa-solid fa-triangle-exclamation"
      color="danger"
    >
      {{ msg }}
    </argon-alert>
    <form @submit.prevent="login">
      <div class="mb-3">
        <input
          ref="emailInput"
          v-model="credentials.email"
          type="email"
          class="form-control form-control-lg"
          placeholder="E-mail"
          name="email"
          autocomplete="username"
          required
        />
      </div>
      <div class="mb-3">
        <input
          v-model="credentials.password"
          class="form-control form-control-lg"
          type="password"
          placeholder="Heslo"
          name="password"
          autocomplete="current-password"
          required
        />
      </div>
      <argon-button
        type="submit"
        class="mt-2"
        color="primary"
        size="lg"
        full-width
      >
        <span v-if="isButtonLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Přihlásit
      </argon-button>
    </form>
    <div class="pt-3 text-center">
      <p class="mx-auto mb-2 text-sm">
        Zapomněl jsi heslo?
        <a
          @click="store.state.showForm = 'forgot-password'"
          href="javascript:;"
          class="text-sm text-primary font-weight-bolder"
        >Obnov si heslo</a>
      </p>
      <p class="mx-auto mb-0 text-sm">
        Nemáš účet?
        <a @click="store.state.showForm = 'register'" class="text-primary font-weight-bolder" href="javascript:;">Zaregistruj se</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, onMounted, nextTick, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import cookies from "vue-cookies";
import ArgonAlert from "@/components/ArgonAlert.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import authService from "@/services/authService.js";

const store = useStore();
const route = useRoute();
const router = useRouter();
const emailInput = ref(null);

const credentials = reactive({
  email: "",
  password: ""
});
const isButtonLoading = computed(() => store.getters["loadingModule/isButtonLoading"]);
const errorMessages = computed(() => {
  if (store.state.alert.type !== "danger") return [];
  const msg = store.state.alert.message;
  if (Array.isArray(msg)) return msg.filter(Boolean);
  if (msg) return [msg];
  return [];
});

onMounted(() => {
  store.dispatch("loadingModule/setButtonLoading", false);
  nextTick(() => emailInput.value?.focus());
});

const login = async () => {
  try {
    store.dispatch("loadingModule/setButtonLoading", true);
    const response = await authService.Login(credentials);

    if (!response) {
      store.dispatch("alertError", ["Přihlášení se nepovedlo. Zkus to znovu."]);
      return;
    }

    if (response.Result) {
      const user = response.Data || {};
      const token = user.SessionHash;
      try {
        if (user.UserID) cookies.set("userID", user.UserID, "30d");
      } catch (e) {
        console.warn(e);
      }
      await store.dispatch("login", { token, user });
      store.commit("SET_AUTH_MODAL", false);
      if (route.path === "/" && !store.state.pendingAddToGame) router.push("/moje-inga");
    } else {
      const err = response.ErrorMessage;
      store.dispatch("alertError", Array.isArray(err) ? err : [err || "Chybné přihlašovací údaje"]);
    }
  } catch (error) {
    console.error(error);
    store.dispatch("alertError", ["Přihlášení se nepovedlo. Zkus to znovu."]);
  } finally {
    store.dispatch("loadingModule/setButtonLoading", false);
  }
};
</script>

<style scoped>
.auth-lead {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: #64748B;
}
</style>
